<div class="df-page">
  <app-project-nav></app-project-nav>
  <app-page-header [title]="'defect.list.pageTitle' | translate" [subtitle]="'defect.list.pageSubtitle' | translate" />

  <div class="df-toolbar">
    <app-filter-dropdown
      name="status"
      [placeholder]="'defect.list.filter.status' | translate"
      [options]="statusOptions()"
      [value]="statusFilter()"
      (valueChange)="onStatusFilter($event)"
    />
    <app-filter-dropdown
      name="release"
      [placeholder]="'defect.list.filter.release' | translate"
      [options]="releaseOptions()"
      [value]="releaseFilter()"
      (valueChange)="onReleaseFilter($event)"
    />
    <app-filter-dropdown
      name="assignee"
      [placeholder]="'defect.list.filter.assignee' | translate"
      [options]="assigneeOptions()"
      [value]="assigneeFilter()"
      (valueChange)="onAssigneeFilter($event)"
    />
  </div>

  @if (loading()) {
    <div class="df-loading" data-testid="defects-loading">
      <mat-spinner diameter="32" />
    </div>
  } @else if (loadError()) {
    <div class="df-hint df-hint--error" role="alert" data-testid="defects-error">
      <p>{{ 'defect.list.loadError' | translate }}</p>
      <button mat-stroked-button type="button" data-testid="defects-retry" (click)="load()">
        {{ 'defect.list.retry' | translate }}
      </button>
    </div>
  } @else if (defects().length === 0) {
    <p class="df-hint" data-testid="defects-empty">
      {{ (hasFilter() ? 'defect.list.emptyFiltered' : 'defect.list.empty') | translate }}
    </p>
  } @else {
    <div class="df-card" role="table" [attr.aria-label]="'defect.list.tableLabel' | translate">
      <div class="df-table-header" role="row">
        <div class="df-col df-col--key" role="columnheader">{{ 'defect.list.column.key' | translate }}</div>
        <div class="df-col df-col--title" role="columnheader">{{ 'defect.list.column.title' | translate }}</div>
        <div class="df-col df-col--severity" role="columnheader">{{ 'defect.list.column.severity' | translate }}</div>
        <div class="df-col df-col--status" role="columnheader">{{ 'defect.list.column.status' | translate }}</div>
        <div class="df-col df-col--assignee" role="columnheader">{{ 'defect.list.column.assignee' | translate }}</div>
        <div class="df-col df-col--ref" role="columnheader">{{ 'defect.list.column.testCase' | translate }}</div>
        <div class="df-col df-col--ref" role="columnheader">{{ 'defect.list.column.testRun' | translate }}</div>
      </div>
      @for (defect of defects(); track defect.id) {
        <div
          class="df-row"
          role="row"
          tabindex="0"
          data-testid="defect-row"
          [attr.aria-label]="defect.key + ' ' + defect.title"
          (click)="open(defect)"
          (keydown.enter)="open(defect)"
        >
          <div class="df-col df-col--key" role="cell">
            <span class="df-key">{{ defect.key }}</span>
          </div>
          <div class="df-col df-col--title" role="cell">
            <span class="df-title">{{ defect.title }}</span>
            @if (defect.blocking) {
              <span class="df-blocking">{{ 'defect.list.blocking' | translate }}</span>
            }
          </div>
          <div class="df-col df-col--severity" role="cell">
            <span class="df-severity" [class]="'df-severity--' + defect.severity.toLowerCase()">
              {{ 'defect.severity.' + defect.severity | translate }}
            </span>
          </div>
          <div class="df-col df-col--status" role="cell" data-testid="defect-status">
            <app-status-pill
              size="sm"
              [kind]="statusKind(defect.status)"
              [label]="'defect.status.' + defect.status | translate"
            />
          </div>
          <div class="df-col df-col--assignee" role="cell" data-testid="defect-assignee">
            {{ defect.assignee?.name ?? ('defect.list.unassigned' | translate) }}
          </div>
          <div class="df-col df-col--ref" role="cell">
            @if (defect.testCaseKey) {
              {{ defect.testCaseKey }}
            } @else {
              <span class="df-missing" data-testid="defect-missing">–</span>
            }
          </div>
          <div class="df-col df-col--ref" role="cell">
            @if (defect.testRunKey) {
              {{ defect.testRunKey }}
            } @else {
              <span class="df-missing" data-testid="defect-missing">–</span>
            }
          </div>
        </div>
      }
    </div>
    <app-overview-pagination
      [pageIndex]="pageIndex()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="pageSizeOptions"
      [totalCount]="totalElements()"
      (pageIndexChange)="onPageIndex($event)"
      (pageSizeChange)="onPageSize($event)"
    />
  }
</div>
